import { Button, Form, FormSelect, Modal } from "react-bootstrap";
import { StyledModalTitle } from "../../../../@ui/StyledModalTitle";
import { Formik } from "formik";
import { LicenceTypeSummary } from "../../../../types/Licences/LicenceTypeSummary";
import { ErrorText } from "../../../../@ui/ErrorText";
import { DeleteSchema } from "./DeleteSchema";
import ThemedModal from "../../../../@ui/Modal/ThemedModal";

interface LicenceDeleteModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: (id: number) => void;
  licenceTypeSummary: LicenceTypeSummary;
}

interface FormValues {
  id: number | undefined;
}

const LicenceTypeDeleteModal = ({
  show,
  onClose,
  onSubmit,
  licenceTypeSummary,
}: LicenceDeleteModalProps) => {
  const initialValues = { id: undefined } as FormValues;
  return (
    <ThemedModal centered show={show} onHide={onClose}>
      <Formik
        validationSchema={DeleteSchema}
        onSubmit={(values: FormValues) => onSubmit(values.id!)}
        initialValues={initialValues}
      >
        {({
          values,
          handleSubmit,
          handleChange,
          touched,
          errors,
          handleBlur,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Modal.Header className="bg-secondary text-white" closeButton>
              <StyledModalTitle>Delete Licence Type</StyledModalTitle>
            </Modal.Header>
            <Modal.Body>
              <Form.Group>
                <FormSelect
                  value={values.id}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  name="id"
                >
                  <option value={""}>All Licence Types</option>
                  {licenceTypeSummary.licenceTypes.map((lt, index) => (
                    <option key={index} value={lt.id}>
                      {lt.name}
                    </option>
                  ))}
                </FormSelect>
                {errors.id && touched.id && (
                  <ErrorText className="text-danger px-1">
                    {errors.id}
                  </ErrorText>
                )}
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button type="submit" variant="primary">
                Submit
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </ThemedModal>
  );
};

export default LicenceTypeDeleteModal;
